// Exports
export default {
	"unsupportedTouchErrorPage": "unsupportedTouchErrorPage_3zszK",
	"image": "image_zW8Z-",
	"title": "title_2PCvb",
	"description": "description_LZU+Z",
	"yabroLink": "yabroLink_3Tf7M"
};
